import React, { Fragment } from "react";
import { withTranslation } from "react-i18next";

const days = [
  { day: "S", value: 7 },
  { day: "M", value: 1 },
  { day: "T", value: 2 },
  { day: "W", value: 3 },
  { day: "T", value: 4 },
  { day: "F", value: 5 },
  { day: "S", value: 6 },
];

const ScheduleSelection = ({
  t,
  scheduleWeek,
  schedule,
  onScheduleChange,
  onScheduleEdit,
  error,
}) => {
  return (
    <div className="schedule-list">
      <label>{t("accountOwner.selectSchedule")}</label>
      <ul>
        {scheduleWeek.length > 0 &&
          scheduleWeek.map((item, index) => (
            <li key={item.value}>
              <label>
                <input
                  type="checkbox"
                  value={item.value}
                  onChange={(e) => onScheduleEdit(e, index)}
                  checked={item.active}
                />
                <span>{item.label}</span>
              </label>
            </li>
          ))}

        {scheduleWeek.length === 0 && (
          <Fragment>
            {days.map((val, i) => (
              <li key={i}>
                <label>
                  <input
                    type="checkbox"
                    value={val.value}
                    onChange={onScheduleChange}
                    checked={schedule.includes(val.value.toString())}
                  />
                  <span>{val.day}</span>
                </label>
              </li>
            ))}
          </Fragment>
        )}
      </ul>
      {error && <span className="error-msg">{error}</span>}
    </div>
  );
};

export default withTranslation()(ScheduleSelection);
